import React, { useRef } from 'react'
import FormController from '../../components/form-controller/form-controller'
import FormHeader from '../../components/FormHeader'
import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  box-sizing: border-box;
`

export default function Page() {
  const headerRef = useRef(null)

  return (
    <Container>
      <FormHeader
        ref={headerRef}
        title="HERE COMES THE GLAM"
        content="We're so excited to bring your bridal beauty vision to life. To get started, we need a few details about your big day. Once submitted, a member of our wedding concierge booking team will be in touch with next steps."
        redirect='/weddings/contact'
      />
      <FormController formName="wedding" headerRef={headerRef} />
    </Container>
  )
}
